import classNames from 'classnames';
import React, { useRef, useEffect } from 'react';
import popupBalloonStyles from './PopupBalloon.module.scss';

export const popupBalloonEvents = {
  mouseDown: 'mousedown',
  mouseOut: 'mouseout',
};

export const popupBalloonPresets = {
  navbar: 'navbar',
  navbarLarge: 'navbarLarge',
  boardEntry: 'boardEntry',
};

const PopupBalloon = ({
  title,
  preset = '',
  dismiss = popupBalloonEvents.mouseOut,
  visible,
  setVisibility,
  children,
  className = '',
  ...otherProps
}) => {
  const popupBalloonRef = useRef(null);

  const popupBalloonClasses = `${popupBalloonStyles.popupBalloon} ${
    popupBalloonStyles[preset] || ''
  } ${className}
  `.trim();

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        popupBalloonRef.current &&
        !popupBalloonRef.current.contains(event.target)
      ) {
        setVisibility(false);
      }
    }

    document.addEventListener(dismiss, handleClickOutside);
    return () => {
      document.removeEventListener(dismiss, handleClickOutside);
    };
  }, [popupBalloonRef, setVisibility, dismiss]);

  return (
    <>
      {visible ? (
        <div
          className={popupBalloonClasses}
          ref={popupBalloonRef}
          {...otherProps}
        >
          <aside>
            <div className={popupBalloonStyles.innerAside}></div>
          </aside>
          {title && <header>{title}</header>}
          <div className={popupBalloonStyles.popupBalloonContent}>
            {children}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default PopupBalloon;
